module.exports = __webpack_public_path__ + "media/images/site/estrada3-2a9a3434018c3cfdd26a345dc1f83815.jpg";